import React from 'react';
import { useSelector } from 'react-redux';

import Button from '../commons/Button';

const ProcessLoader = () => {
  const {
    totalSteps,
    currentStep,
    humanMessage,
    apiMessage,
    buttons,
    image,
  } = useSelector((state) => state.ui.processStatus);

  return (
    <div className="app-loader">
      <div className={`app-loader-inner -process -${image}`}>
        <p>
          Paso&nbsp;
          {currentStep}
          &nbsp;de&nbsp;
          {totalSteps}
        </p>
        <div className="loader-icon" />
        <p>{humanMessage}</p>
        {apiMessage && (
          apiMessage.split('%%').map((message) => <p key={message}>{message}</p>)
        )}
        {buttons && buttons.map((button) => (
          <Button
            key={button.label}
            onClick={button.action}
            label={button.label}
            iconPosition={button.iconPosition}
            buttonClasses={`align-center ${button?.buttonClasses ? button.buttonClasses : ''}`}
            iconClasses={button.icon} />
        ))}
      </div>
    </div>
  );
};

export default ProcessLoader;
